import {
  KEYCLOAK_AUTH_SUCCESS,
  KEYCLOAK_AUTH_ERROR,
  KEYCLOAK_IN_PROGRESS,
  KEYCLOAK_REFRESH_TRANSIENT_ERROR,
  SESSION_EXPIRED,
} from '../actions/types';

const initialState = {
  inProgress: false,
  error: null,
  loggedIn: false,
  sessionExpired: false,
};

export default function keycloakReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case KEYCLOAK_IN_PROGRESS: return { ...state, inProgress: true, error: null };
    case KEYCLOAK_AUTH_SUCCESS: return { ...state, loggedIn: true, inProgress: false, error: null, sessionExpired: false };
    case KEYCLOAK_AUTH_ERROR: return { ...state, loggedIn: false, inProgress: false, error: payload };
    // A refresh that failed while keycloak kept the tokens is transient: only reset inProgress,
    // never touch sessionExpired/loggedIn — a 401 path may already have opened the modal.
    case KEYCLOAK_REFRESH_TRANSIENT_ERROR: return { ...state, inProgress: false };
    // Keep loggedIn true so requireAuth keeps rendering (with the modal) instead of a full-page spinner.
    case SESSION_EXPIRED: return { ...state, inProgress: false, error: null, sessionExpired: true };
    default:
  }

  return state;
}
